"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StickyButtons = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_next_1 = require("@geome/react-next");
const react_1 = require("react");
const StickyButtons = ({ directionsLink, locatorLink, offersLength, shown, }) => {
    const className = (0, react_next_1.useBEM)({
        block: "sticky-buttons",
        modifiers: {
            shown: shown,
        },
    });
    const { translate } = (0, react_next_1.useI18n)();
    const { isMobile } = (0, react_1.useContext)(react_next_1.EnvironmentContext);
    if (isMobile)
        return null;
    return ((0, jsx_runtime_1.jsx)("div", { className: className, "aria-hidden": true, children: (0, jsx_runtime_1.jsxs)("div", { className: "sticky-buttons__container", children: [(0, jsx_runtime_1.jsx)("a", { className: "sticky-buttons__button", href: directionsLink, children: translate("station_page.sections.info.get_directions") }), offersLength > 0 && ((0, jsx_runtime_1.jsx)("a", { className: "sticky-buttons__button", href: "#offers-anchor", children: translate("station_page.sections.info.offers") })), (0, jsx_runtime_1.jsx)("a", { className: "sticky-buttons__button sticky-buttons__button--fit-content", href: locatorLink, children: translate("station_page.sections.info.station_locator") })] }) }));
};
exports.StickyButtons = StickyButtons;
